import { listBase } from './listCssDefs';
import React from 'react';

import {
  OmakasePolymorphicComponent,
  OmakasePolymorphicComponentProps,
  OmakasePolymorphicRootComponent,
} from '../utils/OmakasePolymorphicComponent';

const ListDefaultElement = 'ul';
type ListTypeGuard = 'ul';

const List: OmakasePolymorphicComponent<{}, typeof ListDefaultElement, ListTypeGuard> =
  React.forwardRef(
    <E extends React.ElementType = typeof ListDefaultElement>(
      { children, component, ...rest }: OmakasePolymorphicComponentProps<{}, E, ListTypeGuard>,
      ref: React.Ref<HTMLUListElement> | undefined
    ) => {
      const Component: React.ElementType = component || ListDefaultElement;

      return (
        <OmakasePolymorphicRootComponent css={listBase} ref={ref} component={Component} {...rest}>
          {children}
        </OmakasePolymorphicRootComponent>
      );
    }
  );

export default List;
